/** Minimum hold duration for cycle looks (seconds). */
export const MIN_CYCLE_HOLD_SECONDS = 30;
export const CYCLE_HOLD_STEP_SECONDS = 30;

/** Snap cycle look hold to 30-second increments, minimum 30. */
export function normalizeCycleHold(hold) {
	const n = typeof hold === 'number' && !Number.isNaN(hold) ? hold : MIN_CYCLE_HOLD_SECONDS;
	return Math.max(MIN_CYCLE_HOLD_SECONDS, Math.round(n / CYCLE_HOLD_STEP_SECONDS) * CYCLE_HOLD_STEP_SECONDS);
}

/** Normalize scene type from document fields. */
export function getSceneType(scene) {
	if (!scene) return 'single';
	if (scene.type === 'cycle' || scene.type === 'single') return scene.type;
	if (scene.looks?.length > 1) return 'cycle';
	return 'single';
}

/** First-look colors for preview / activation. */
export function getScenePreviewColors(scene) {
	if (!scene) return [];
	if (scene.looks?.[0]?.colors?.length) return scene.looks[0].colors;
	return scene.colors || [];
}

/** Build looks array from legacy or unified scene doc. */
export function normalizeSceneLooks(scene, numColors = 4) {
	const defaultColors = Array.from({ length: numColors }, () => ({ r: 128, g: 128, b: 128 }));
	if (scene?.looks?.length) {
		const isCycle = getSceneType(scene) === 'cycle';
		return scene.looks.map((l) => ({
			colors: l.colors?.length ? l.colors : defaultColors,
			hold: isCycle ? normalizeCycleHold(l.hold) : 0,
		}));
	}
	if (scene?.colors?.length) {
		return [{ colors: scene.colors, hold: 0 }];
	}
	return [{ colors: defaultColors, hold: 0 }];
}
